import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles({
  root: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    border: '2px solid #6C7A89',
    '&:hover': {
      backgroundColor: '#ECF0F1',
    },
  },
  label: {
    color: '#6C7A89',
    textTransform: 'uppercase',
    fontSize: '14pt',
  },
});

interface ButtonProps {
  children: any;
  type?: any;
  onClick?: (e: any) => void;
  [x: string]: any;
}

const NeutralButton = (props: ButtonProps) => {
  const { children, ...other } = props;
  const classes = useStyles();
  return (
    <Button
      classes={{
        root: classes.root, // class name, e.g. `classes-nesting-root-x`
        label: classes.label, // class name, e.g. `classes-nesting-label-x`
      }}
      {...other}
    >
      {children || ''}
    </Button>
  );
};

export default NeutralButton;
